import { render, staticRenderFns } from "./authmanage.vue?vue&type=template&id=33949f78&scoped=true"
import script from "./authmanage.vue?vue&type=script&lang=js"
export * from "./authmanage.vue?vue&type=script&lang=js"
import style0 from "./authmanage.vue?vue&type=style&index=0&id=33949f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33949f78",
  null
  
)

export default component.exports